import v2024 from '@/sui/data/sheets/edit/observa4/2024'

import { fromField } from '@/sui/data/caracteristics/tools'
import ctx from '@/sui/data/caracteristics/observa4/context'

const ofields = v2024.fields

export default {
  p1: [
    fromField('p1b lieu', ofields.place.p1),
    fromField('p1b lieu autre', ofields.otherPlace.p1),
    fromField('p1b dispositif', ofields.catheterType.p1),
    fromField('p1b dispositif autre (2021+)', ofields.otherCatheterType.p1),
    fromField('p1b site insertion (2023+)', ofields.insertionSite.p1),
    fromField('p1b site insertion autre (2023+)', ofields.insertionSiteDetail.p1r1),

    { f: 'p1b audité', t: `L'audité`, h: true },
    fromField('p1b audité', ofields.audited.p1, null, true),
    fromField('p1b audité autre (2022+)', ofields.auditedDetail.p1),
    fromField('p1b étudiant', ofields.student.all),
    fromField('p1b casaque stérile', ofields.sterileGown.p1),
    fromField('p1b coiffe audité', ofields.auditedCap.p1p3r1),
    fromField('p1b coiffe conforme audité', ofields.compliantAuditedCap.p1p3r1),
    fromField('p1b masque audité', ofields.auditedMask.p1p3b2r1),
    fromField('p1b masque conformité audité', ofields.compliantAuditedMask.p1p3b2r1),

    { f: 'p1b adulte', t: 'Le patient', h: true },
    fromField('p1b adulte', ofields.isAdult.p1p2p3r1),
    fromField('p1b âge enfant', ofields.childAge.p1p2p3r1),
    fromField('p1b tenue propre patient', ofields.patientCleanOutfit.p1p2p3p4b2),
    fromField('p1b masque patient', ofields.patientMask.p1p3b2r1, 3),
    fromField('p1b masque conforme patient', ofields.compliantPatientMask.p1p3b2r1),
    fromField('p1b visage couvert patient', ofields.patientSterileField.p1r1),
    fromField('p1b coiffe patient', ofields.patientCap.p1),
    fromField('p1b coiffe conforme patient', ofields.compliantPatientCap.p1),
    fromField('p1b tête couverte patient (2024+)', ofields.patientHeadSterileField.p1),

    { f: 'p1b echo (2023+)', t: 'Échoguidage', h: true },
    fromField('p1b echo (2023+)', ofields.withUltrasound.p1),
    fromField('p1b echo opérateur repérage (2023+)', ofields.usAuditedSearch.p1),
    fromField('p1b echo repère gel (2023+)', ofields.searchGelUsed.p1),
    fromField('p1b echo repère date sur flacon (2023+)', ofields.vialOpeningDateWritten.p1),
    fromField('p1b echo repère flacon ouvert (2023+)', ofields.vialOpenedSince.p1),
    fromField('p1b echo repère gaine (2023+)', ofields.searchUltrasoundSheath.p1),
    fromField('p1b echo repère gaine retrait (2023+)', ofields.sheathRemoval.p1),
    fromField('p1b echo repère essuyage (2023-2025)', ofields.ultrasoundWipingSearch.p1[0]),
    fromField('p1b echo repère essuyage produit (2023-2025)', ofields.ultrasoundWipingSearch.p1[1]),

    { f: 'p1b peau nécessitant nettoyage', t: `Préparation du site d'insertion`, h: true },
    fromField('p1b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3p4),
    fromField('p1b nettoyage', ofields.insertionSiteCleaned.p1p2p3p4r1),
    fromField('p1b application antiseptique', ofields.antiseptic.p1p2p3p4[0]),
    fromField('p1b antiseptique', ofields.antiseptic.p1p2p3p4[1]),
    fromField('p1b antiseptique autre', ofields.antiseptic.p1p2p3p4[2]),
    fromField('p1b compresses (2021+)', ofields.useCompresses.p1p2p3p4, 3),
    fromField('p1b type compresses (2021+)', ofields.compressesType.p1p2p3p4),
    fromField('p1b séchage spontané', ofields.dry.p1p2p3p4, null, null, ctx.p1),

    { f: 'p1b hdm pose', t: `Port des gants et hygiène des mains`, h: true },
    fromField('p1b gants pose (2021+)', ofields.gloves.p1),
    fromField('p1b gants pose type (2021+)', ofields.glovesType.p1),
    fromField('p1b gants enfilés (2024+)', ofields.glovesPutOn.p1),
    fromField('p1b hdm pose', ofields.handHygieneBeforeInsertionGloves.p1[0]),
    fromField('p1b hdm pose type (2023+)', ofields.handHygieneBeforeInsertionGloves.p1[1]),
    fromField('p1b hdm pose conforme', ofields.handHygieneBeforeInsertionGloves.p1[2]),

    { f: 'p1b echo pose gaine (2023+)', t: `Pose sous échoguidage`, h: true },
    fromField('p1b echo pose gaine (2023+)', ofields.insertionUltrasoundSheath.p1),
    fromField('p1b echo pose sonde recouverte (2023+)', ofields.probeCovered.p1),
    fromField('p1b echo pose gaine immédiatement avant (2023-2025)', ofields.sheathJustBeforeInsertion.p1),
    fromField('p1b echo pose gel utilisé (2023+)', ofields.insertionGelUsed.p1),
    fromField('p1b echo pose gel appliqué (2023+)', ofields.gelApplied.p1),
    fromField('p1b echo pose contact sonde aiguille (2023+)', ofields.probeNeedleContact.p1),
    fromField('p1b echo pose touche échographe (2023+)', ofields.auditedTouchProbe.p1),
    fromField('p1b echo pose touche avec (2023+)', ofields.probeTouchedWith.p1),
    fromField('p1b echo pose touche avec autre (2023+)', ofields.probeTouchedWithDetail.p1),
    fromField('p1b echo pose touche retrait gants (2023+)', ofields.glovesRemoval.p1),
    fromField('p1b echo pose gaine inspectée (2023+)', ofields.nakedEyeSheathInspection.p1),
    fromField('p1b echo pose sonde inspectée (2023+)', ofields.probeInspection.p1),
    fromField('p1b echo pose sonde déchirée (2023+)', ofields.tearedSheath.p1),
    fromField('p1b echo pose sonde sale (2023+)', ofields.dirtyProbe.p1),
    fromField('p1b echo pose sonde entretenue (2023+)', ofields.probeCleaned.p1),
    fromField('p1b echo pose sonde nettoyage (2023+)', ofields.probeCleaningMethod.p1),
    fromField('p1b echo pose sonde nettoyage autre (2023+)', ofields.probeCleaningMethodDetail.p1),
    fromField('p1b echo pose sonde essuyage produit (2023+)', ofields.probeCleaningProduct.p1[0]),
    fromField('p1b echo pose sonde essuyage produit autre (2023+)', ofields.probeCleaningProduct.p1[1]),

    { f: 'p1b pkoi opérateur laisse gaine après repérage (2023+)', t: `Entretien avec l'audité`, h: true },
    fromField('p1b pkoi opérateur laisse gaine après repérage (2023+)', ofields.whySheathNotRemovedAfterSearch.p1[0]),
    fromField('p1b pkoi opérateur laisse gaine après repérage autre (2023+)', ofields.whySheathNotRemovedAfterSearch.p1[1]),
    fromField('p1b pkoi asq non chlorex 2% adulte (2024+)', ofields.whyNotChlAlc2Percent.p1[0]),
    fromField('p1b pkoi asq non chlorex 2% adulte autre (2024+)', ofields.whyNotChlAlc2Percent.p1[1]),
    fromField('p1b pkoi opérateur continue après contact (2023+)', ofields.whyNotRemoveGlovesAfterTouch.p1[0]),
    fromField('p1b pkoi opérateur continue après contact autre (2023+)', ofields.whyNotRemoveGlovesAfterTouch.p1[1])
  ],

  p2: [
    fromField('p2b dispositif', ofields.catheterType.p2),
    { f: 'p2b audité', t: `L'audité`, h: true },
    fromField('p2b audité', ofields.audited.p2b1b2),
    fromField('p2b étudiant', ofields.student.all),
    fromField('p2b tenue propre audité', ofields.auditedCleanOutfit.p2p3p4b1b2),
    { f: 'p2b adulte', t: 'Le patient', h: true },
    fromField('p2b adulte', ofields.isAdult.p1p2p3r1),
    fromField('p2b âge enfant', ofields.childAge.p1p2p3r1),
    fromField('p2b tenue propre patient', ofields.patientCleanOutfit.p1p2p3p4b2),
    { f: 'p2b prepa hdm', t: `Préparation du site d'insertion`, h: true },
    fromField('p2b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3p4),
    fromField('p2b nettoyage', ofields.insertionSiteCleaned.p1p2p3p4r1),
    fromField('p2b application antiseptique', ofields.antiseptic.p1p2p3p4[0]),
    fromField('p2b antiseptique', ofields.antiseptic.p1p2p3p4[1]),
    fromField('p2b antiseptique autre', ofields.antiseptic.p1p2p3p4[2]),
    fromField('p2b compresses (2021+)', ofields.useCompresses.p1p2p3p4, 3),
    fromField('p2b type compresses (2021+)', ofields.compressesType.p1p2p3p4),
    fromField('p2b séchage spontané', ofields.dry.p1p2p3p4, null, null, ctx.p2),
    { f: 'p2b pose hdm', t: `Port des gants et hygiène des mains`, h: true },
    fromField('p2b pose gants', ofields.gloves.p2p3),
    fromField('p2b pose gants type', ofields.glovesType.p2p3b1),
    fromField(
      'p2b pose gants enfilés (2022+)', ofields.glovesPutOn.p2p3, null, null, ctx.p2
    ),
    fromField('p2b palpation', ofields.palpation.p2),

    fromField('p2b prepa hdm', ofields.handHygieneBeforePreparation.p2[0]),
    fromField('p2b prepa hdm type', ofields.handHygieneBeforePreparation.p2[1]),
    fromField('p2b prepa hdm conforme', ofields.handHygieneBeforePreparation.p2[2]),

    fromField('p2b pose hdm', ofields.handHygieneBeforePeriInsertion.p2p4[0]),
    fromField('p2b pose hdm type', ofields.handHygieneBeforePeriInsertion.p2p4[1]),
    fromField('p2b pose hdm conforme', ofields.handHygieneBeforePeriInsertion.p2p4[2]),
    { f: 'p2b pkoi asq non alcoolique adulte', t: `Entretien avec l'audité`, h: true },
    fromField('p2b pkoi asq non alcoolique adulte', ofields.whyNotAlcool.p2p3p4[0]),
    fromField('p2b pkoi asq non alcoolique adulte autre', ofields.whyNotAlcool.p2p3p4[1]),
    fromField('p2b pkoi pas gants stériles après palpation (2024+)', ofields.whyNotSGForPalpation.p2[0]),
    fromField('p2b pkoi pas gants stériles après palpation autre (2024+)', ofields.whyNotSGForPalpation.p2[1]),
    fromField('p2b pkoi pas hdm insertion', ofields.whyNotHH.p2[0]),
    fromField('p2b pkoi pas hdm insertion autre', ofields.whyNotHH.p2[1]),
    fromField('p2b pkoi hdm non conforme (2022-2025)', ofields.whyNotHHCompliant.p2[0]),
    fromField('p2b pkoi hdm non conforme autre (2022-2025)', ofields.whyNotHHCompliant.p2[1])
  ],

  p3: [
    { f: 'p3b audited', t: `L'audité`, h: true },
    fromField('p3b audité', ofields.audited.p3p4r1),
    fromField('p3b audité autre (2022+)', ofields.auditedDetail.p3p4r1),
    fromField('p3b étudiant', ofields.student.all),
    fromField('p3b tenue propre audité', ofields.auditedCleanOutfit.p2p3p4b1b2),
    fromField('p3b coiffe audité', ofields.auditedCap.p1p3r1),
    fromField('p3b coiffe conforme audité', ofields.compliantAuditedCap.p1p3r1),
    fromField('p3b masque audité', ofields.auditedMask.p1p3b2r1),
    fromField('p3b masque conforme audité', ofields.compliantAuditedMask.p1p3b2r1),
    { f: 'p3b adulte', t: 'Le patient', h: true },
    fromField('p3b adulte', ofields.isAdult.p1p2p3r1),
    fromField('p3b âge enfant', ofields.childAge.p1p2p3r1),
    fromField('p3b tenue propre patient', ofields.patientCleanOutfit.p1p2p3p4b2),
    fromField('p3b masque patient', ofields.patientMask.p1p3b2r1),
    fromField('p3b masque conforme patient', ofields.compliantPatientMask.p1p3b2r1),
    fromField('p3b visage tourné patient', ofields.patientOtherSide.p3b2r1),

    { f: 'p3b peau nécessitant nettoyage', t: `Antisepsie`, h: true },
    fromField('p3b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3p4),
    fromField('p3b nettoyage', ofields.insertionSiteCleaned.p1p2p3p4r1),
    fromField('p3b application antiseptique', ofields.antiseptic.p1p2p3p4[0]),
    fromField('p3b antiseptique', ofields.antiseptic.p1p2p3p4[1]),
    fromField('p3b antiseptique autre', ofields.antiseptic.p1p2p3p4[2]),
    fromField('p3b compresses (2021+)', ofields.useCompresses.p1p2p3p4, 3),
    fromField('p3b type compresses (2021+)', ofields.compressesType.p1p2p3p4),
    fromField('p3b séchage spontané', ofields.dry.p1p2p3p4, null, null, ctx.p3),
    fromField('p3b champ stérile troué préfendu (2023+)', ofields.preFencedSterileField.p3),

    { f: 'p3b gants', t: `Port des gants et hygiène des mains`, h: true },
    fromField('p3b gants', ofields.gloves.p2p3),
    fromField('p3b gants type', ofields.glovesType.p2p3b1),
    fromField(
      'p3b gants enfilés (2023+)', ofields.glovesPutOn.p2p3, null, null, ctx.p3
    ),
    fromField('p3b prepa hdm', ofields.handHygieneBeforePrepaOrInstall.p3b2[0]),
    fromField('p3b prepa hdm type', ofields.handHygieneBeforePrepaOrInstall.p3b2[1]),
    fromField('p3b prepa hdm conforme', ofields.handHygieneBeforePrepaOrInstall.p3b2[2]),
    fromField('p3b enfilage hdm (2024+)', ofields.handHygieneBeforeGloves.p3[0]),
    fromField('p3b enfilage hdm type (2024+)', ofields.handHygieneBeforeGloves.p3[1]),
    fromField('p3b enfilage hdm conforme (2024+)', ofields.handHygieneBeforeGloves.p3[2]),
    fromField('p3b sans gants hdm (2024+)', ofields.handHygieneBeforePuncture.p3[0]),
    fromField('p3b sans gants hdm type (2024+)', ofields.handHygieneBeforePuncture.p3[1]),
    fromField('p3b sans gants hdm conforme (2024+)', ofields.handHygieneBeforePuncture.p3[2]),

    { f: 'p3b pkoi tenue audité non conforme', t: `Entretien avec l'audité`, h: true },
    fromField('p3b pkoi tenue audité non conforme', ofields.whyNCAuditedOutfit.p3[0]),
    fromField('p3b pkoi tenue audité non conforme autre', ofields.whyNCAuditedOutfit.p3[1]),
    fromField('p3b pkoi tenue patient non conforme', ofields.whyNCPatientOutfit.p3[0]),
    fromField('p3b pkoi tenue patient non conforme autre', ofields.whyNCPatientOutfit.p3[1]),
    fromField('p3b pkoi asq non alcoolique adulte', ofields.whyNotAlcool.p2p3p4[0]),
    fromField('p3b pkoi asq non alcoolique adulte autre', ofields.whyNotAlcool.p2p3p4[1])
    // missing whyNotHHBeforeGloves
  ],

  p4: [
    fromField('p4b ehpad', ofields.isEhpad.p4),
    fromField('p4b dispositif', ofields.catheterType.p4),
    { f: 'p4b audité', t: `L'audité`, h: true },
    fromField('p4b audité', ofields.audited.p3p4r1),
    fromField('p4b audité autre (2022+)', ofields.auditedDetail.p3p4r1),
    fromField('p4b étudiant', ofields.student.all),
    fromField('p4b tenue propre audité', ofields.auditedCleanOutfit.p2p3p4b1b2),
    { f: 'p4b tenue propre patient', t: 'Le patient / résident', h: true },
    fromField('p4b tenue propre patient', ofields.patientCleanOutfit.p1p2p3p4b2),
    { f: 'p4b prepa hdm', t: `Préparation du site d'insertion`, h: true },
    fromField('p4b prepa hdm', ofields.handHygieneBeforeAntisepsis.p4[0]),
    fromField('p4b prepa hdm type', ofields.handHygieneBeforeAntisepsis.p4[1]),
    fromField('p4b prepa hdm conforme', ofields.handHygieneBeforeAntisepsis.p4[2]),
    fromField('p4b peau nécessitant nettoyage', ofields.dirtySkin.p1p2p3p4),
    fromField('p4b nettoyage', ofields.insertionSiteCleaned.p1p2p3p4r1),
    fromField('p4b application antiseptique', ofields.antiseptic.p1p2p3p4[0]),
    fromField('p4b antiseptique', ofields.antiseptic.p1p2p3p4[1]),
    fromField('p4b antiseptique autre', ofields.antiseptic.p1p2p3p4[2]),
    fromField('p4b compresses', ofields.useCompresses.p1p2p3p4, 3),
    fromField('p4b type compresses', ofields.compressesType.p1p2p3p4),
    fromField('p4b nb passages antiseptique', ofields.antisepticPassages.p4),
    fromField('p4b séchage spontané', ofields.dry.p1p2p3p4, null, null, ctx.p4),
    { f: 'p4b pose hdm', t: `Insertion du catheter`, h: true },
    fromField(
      'p4b pose hdm', ofields.handHygieneBeforePeriInsertion.p2p4[0]
    ),
    fromField(
      'p4b pose hdm type', ofields.handHygieneBeforePeriInsertion.p2p4[1]
    ),
    fromField(
      'p4b pose hdm conforme', ofields.handHygieneBeforePeriInsertion.p2p4[2]
    ),
    fromField('p4b pose gants', ofields.gloves.p4),
    fromField('p4b pose gants type', ofields.glovesType.p4),
    fromField('p4b maintien tissu', ofields.holdTissue.p4),
    { f: 'p4b pkoi asq non alcoolique adulte', t: `Entretien avec l'audité`, h: true },
    fromField('p4b pkoi asq non alcoolique adulte', ofields.whyNotAlcool.p2p3p4[0]),
    fromField('p4b pkoi asq non alcoolique adulte autre', ofields.whyNotAlcool.p2p3p4[1]),
    fromField('p4b pkoi pas hdm insertion', ofields.whyNotHH.p4[0]),
    fromField('p4b pkoi pas hdm insertion autre', ofields.whyNotHH.p4[1]),
    fromField('p4b pkoi pas de gants', ofields.whyNotGloves.p4[0]),
    fromField('p4b pkoi pas de gants autre', ofields.whyNotGloves.p4[1])
  ],

  b1: [
    fromField('b1b dispositif', ofields.catheterType.b1),
    { f: 'b1b audité', t: `L'audité`, h: true },
    fromField('b1b audité', ofields.audited.p2b1b2),
    fromField('b1b étudiant', ofields.student.all),
    fromField('b1b tenue propre audité', ofields.auditedCleanOutfit.p2p3p4b1b2),
    {
      f: 'b1b manip hdm',
      t: `Désinfection du site de branchement`,
      h: true
    },
    fromField('b1b manip hdm', ofields.handHygieneBeforeDisinfection.b1[0]),
    fromField('b1b manip hdm type', ofields.handHygieneBeforeDisinfection.b1[1]),
    fromField('b1b manip hdm conforme', ofields.handHygieneBeforeDisinfection.b1[2]),
    fromField('b1b compresses (2021+)', ofields.useCompresses.b1b2, 3),
    fromField('b1b compresses type (2021+)', ofields.compressesType.b1b2),
    fromField('b1b application antiseptique', ofields.antiseptic.b1[0]),
    fromField('b1b antiseptique', ofields.antiseptic.b1[1]),
    fromField('b1b antiseptique autre', ofields.antiseptic.b1[2]),
    { f: 'b1b valve', t: `Valve`, h: true },
    fromField('b1b valve', ofields.valve.b1b2),
    fromField('b1b valve désinfection', ofields.valveAntiseptic.b1b2[0]),
    fromField('b1b valve désinfection conforme', ofields.valveAntiseptic.b1b2[1]),
    fromField('b1b valve antiseptique', ofields.valveAntiseptic.b1b2[2]),
    fromField('b1b valve antiseptique autre', ofields.valveAntiseptic.b1b2[3]),

    fromField('b1b gants nécessaires (2022+)', ofields.glovesNecessary.b1),
    fromField('b1b gants', ofields.gloves.b1),
    fromField('b1b gants type (2021+)', ofields.glovesType.p2p3b1),

    { f: 'b1b pkoi pas hdm manipulation', t: `Entretien avec l'audité`, h: true },
    fromField('b1b pkoi pas hdm manipulation', ofields.whyNotHHM.b1[0]),
    fromField('b1b pkoi pas hdm manipulation autre', ofields.whyNotHHM.b1[1]),
    fromField('b1b pkoi pas compresses désinfection (2021+)', ofields.whyNotCompresses.b1[0]),
    fromField('b1b pkoi pas compresses désinfection autre (2021+)', ofields.whyNotCompresses.b1[1]),
    fromField('b1b pkoi pas stériles compresses (2021+)', ofields.whyNotSterileCompresses.b1[0]),
    fromField('b1b pkoi pas stériles compresses autre (2021+)', ofields.whyNotSterileCompresses.b1[1]),
    fromField('b1b pkoi pas valve désinfectée', ofields.whyNotDisinfectValve.b1b2[0]),
    fromField('b1b pkoi pas valve désinfectée autre', ofields.whyNotDisinfectValve.b1b2[1])
  ],

  b2: [
    fromField('b2b dispositif', ofields.catheterType.b2),
    fromField('b2b manip type (2023+)', ofields.manipType.b2),
    fromField('b2b manip type autre (2023+)', ofields.otherManipType.b2),
    { f: 'b2b audité', t: `L'audité`, h: true },
    fromField('b2b audité', ofields.audited.p2b1b2),
    fromField('b2b étudiant', ofields.student.all),
    fromField('b2b tenue propre audité', ofields.auditedCleanOutfit.p2p3p4b1b2),
    fromField('b2b masque audité', ofields.auditedMask.p1p3b2r1),
    fromField('b2b masque conforme audité', ofields.compliantAuditedMask.p1p3b2r1),
    fromField('b2b coiffe audité (2024+)', ofields.auditedCap.b2),
    fromField('b2b coiffe conforme audité (2024+)', ofields.compliantAuditedCap.b2),

    { f: 'b2b tenue propre patient', t: `Le patient`, h: true },
    fromField('b2b tenue propre patient', ofields.patientCleanOutfit.p1p2p3p4b2),
    fromField('b2b masque patient', ofields.patientMask.p1p3b2r1),
    fromField('b2b masque conforme patient', ofields.compliantPatientMask.p1p3b2r1),
    fromField('b2b visage tourné patient', ofields.patientOtherSide.p3b2r1),

    {
      f: 'b2b hdm prepa (2023+)',
      t: `Désinfection du site de branchement`,
      h: true
    },
    fromField('b2b hdm prepa (2023+)', ofields.handHygieneBeforePrepaOrInstall.p3b2[0]),
    fromField('b2b hdm prepa type (2023+)', ofields.handHygieneBeforePrepaOrInstall.p3b2[1]),
    fromField('b2b hdm prepa conforme (2023+)', ofields.handHygieneBeforePrepaOrInstall.p3b2[2]),
    fromField('b2b compresses (2021+)', ofields.useCompresses.b1b2, 3),
    fromField('b2b type compresses (2021+)', ofields.compressesType.b1b2),

    fromField('b2b application antiseptique', ofields.antiseptic.b2[0]),
    fromField('b2b antiseptique', ofields.antiseptic.b2[1]),
    fromField('b2b antiseptique autre', ofields.antiseptic.b2[2]),

    { f: 'b2b valve', t: `Valve`, h: true },
    fromField('b2b valve', ofields.valve.b1b2),
    fromField('b2b valve désinfection', ofields.valveAntiseptic.b1b2[0]),
    fromField('b2b valve désinfection conforme (2021+)', ofields.valveAntiseptic.b1b2[1]),
    fromField('b2b valve antiseptique', ofields.valveAntiseptic.b1b2[2]),
    fromField('b2b valve antiseptique autre', ofields.valveAntiseptic.b1b2[3]),

    {
      f: 'b2b hdm gloves',
      t: `Port des gants et hygiène des mains`,
      h: true
    },

    fromField('b2b gants (2021+)', ofields.gloves.b2),
    fromField('b2b gants type (2021+)', ofields.glovesType.b2),
    fromField('b2b gants enfilés (2023+)', ofields.glovesPutOnManip.b2),

    fromField('b2b hdm avant gants (2024+)', ofields.handHygieneBeforeGloves.b2[0]),
    fromField('b2b hdm avant gants type (2024+)', ofields.handHygieneBeforeGloves.b2[1]),
    fromField('b2b hdm avant gants conforme (2024+)', ofields.handHygieneBeforeGloves.b2[2]),

    fromField('b2b hdm sans gants (2024+)', ofields.handHygieneBeforeManipNoGloves.b2[0]),
    fromField('b2b hdm sans gants type (2024+)', ofields.handHygieneBeforeManipNoGloves.b2[1]),
    fromField('b2b hdm sans gants conforme (2024+)', ofields.handHygieneBeforeManipNoGloves.b2[2]),

    { f: 'b2b pkoi audité pas masque', t: `Entretien avec l'audité`, h: true },
    fromField('b2b pkoi audité pas masque', ofields.whyNotAuditedMask.b2[0]),
    fromField('b2b pkoi audité pas masque autre', ofields.whyNotAuditedMask.b2[1]),
    fromField('b2b pkoi pas valve désinfectée', ofields.whyNotDisinfectValve.b1b2[0]),
    fromField('b2b pkoi pas valve désinfectée autre', ofields.whyNotDisinfectValve.b1b2[1]),
    fromField('b2b pkoi pas gants stériles (2022+)', ofields.whyNotSterileGloves.b2[0]),
    fromField('b2b pkoi pas gants stériles autre (2022+)', ofields.whyNotSterileGloves.b2[1]),
    fromField('b2b pkoi pas hdm manip', ofields.whyNotHHM.b2[0]),
    fromField('b2b pkoi pas hdm manip autre', ofields.whyNotHHM.b2[1])
  ],

  r1: [
    fromField('r1b dispositif', ofields.catheterType.r1),
    fromField('r1b site insertion', ofields.insertionSite.r1),
    fromField('r1b site insertion autre', ofields.insertionSiteDetail.p1r1),
    { f: 'r1b audité', t: `L'audité`, h: true },
    fromField('r1b audité', ofields.audited.p3p4r1),
    fromField('r1b audité autre', ofields.auditedDetail.p3p4r1),
    fromField('r1b étudiant', ofields.student.all),
    fromField('r1b tenue propre ou prot audité', ofields.auditedCleanOutfitOrProt.r1),
    fromField('r1b casaque pour néonat (2024+)', ofields.sterileGown.r1),
    fromField('r1b coiffe audité', ofields.auditedCap.p1p3r1),
    fromField('r1b coiffe conforme audité', ofields.compliantAuditedCap.p1p3r1),
    fromField('r1b masque audité', ofields.auditedMask.p1p3b2r1),
    fromField('r1b masque conforme audité', ofields.compliantAuditedMask.p1p3b2r1),
    { f: 'r1b adulte', t: `Le patient`, h: true },
    fromField('r1b adulte', ofields.isAdult.p1p2p3r1),
    fromField('r1b âge enfant', ofields.childAge.p1p2p3r1),
    fromField('r1b masque patient', ofields.patientMask.p1p3b2r1),
    fromField('r1b masque conforme patient', ofields.compliantPatientMask.p1p3b2r1),
    fromField('r1b visage couvert patient', ofields.patientSterileField.p1r1),
    fromField('r1b visage tourné patient', ofields.patientOtherSide.p3b2r1),
    fromField('r1b dénudation suffisante', ofields.strippingSufficient.r1),
    fromField('r1b imc', ofields.bmi.r1),
    { f: 'r1b réfection programmée', t: `Retrait du pansement en place`, h: true },
    fromField('r1b réfection programmée', ofields.scheduledDressingRepair.r1),
    fromField('r1b pansement souillé', ofields.soiledDressing.r1),
    fromField('r1b pansement décollé', ofields.dressingPeelsOff.r1),
    fromField('r1b hdm prepa', ofields.handHygieneBeforeEquipmentPreparation.r1[0]),
    fromField('r1b hdm prepa type', ofields.handHygieneBeforeEquipmentPreparation.r1[1]),
    fromField('r1b hdm prepa conforme', ofields.handHygieneBeforeEquipmentPreparation.r1[2]),
    fromField('r1b préparation champ stérile', ofields.sterilePreparation.r1),
    fromField('r1b retrait par étirement', ofields.removeDressingByStretching.r1),
    fromField('r1b signes irritation', ofields.signsOfSkinIrritation.r1),
    fromField('r1b retrait gants', ofields.removalGloves.r1),
    fromField('r1b retrait gants type', ofields.removalGlovesType.r1),
    fromField('r1b retrait gants retirés', ofields.glovesRemoval.r1),
    { f: 'r1b stabilisateur', t: `Réfection du pansement`, h: true },
    fromField('r1b stabilisateur', ofields.hasStabilizer.r1),
    fromField('r1b stab change', ofields.changeStabilizer.r1),
    fromField('r1b stab change raison', ofields.changeStabilizerReason.r1),
    fromField('r1b hdm retrait stab (2024+)', ofields.handHygieneBeforeStabilizer.r1[0]),
    fromField('r1b hdm retrait stab type (2024+)', ofields.handHygieneBeforeStabilizer.r1[1]),
    fromField('r1b hdm retrait stab compliant (2024+)', ofields.handHygieneBeforeStabilizer.r1[2]),
    fromField('r1b stab gants', ofields.stabilizerGloves.r1),
    fromField('r1b stab gants type', ofields.stabilizerGlovesType.r1),
    fromField('r1b stab gants retirés', ofields.secondaryGlovesRemoval.r1),
    fromField('r1b nettoyage hdm (2024+)', ofields.handHygieneBeforeAntisepsis.r1[0]),
    fromField('r1b nettoyage hdm type (2024+)', ofields.handHygieneBeforeAntisepsis.r1[1]),
    fromField('r1b nettoyage hdm conforme (2024+)', ofields.handHygieneBeforeAntisepsis.r1[2]),
    fromField('r1b nettoyage gants', ofields.repairGloves.r1),
    fromField('r1b nettoyage gants type', ofields.repairGlovesType.r1),
    fromField('r1b nettoyage', ofields.insertionSiteCleaned.p1p2p3p4r1),
    fromField('r1b savon', ofields.soap.r1),
    fromField('r1b rinçage', ofields.rinsing.r1),
    fromField('r1b séchage avec compresses', ofields.dryingWithSterileCompresses.r1),
    fromField('r1b application antiseptique', ofields.antiseptic.r1[0]),
    fromField('r1b antiseptique', ofields.antiseptic.r1[1]),
    fromField('r1b antiseptique autre', ofields.antiseptic.r1[2]),
    fromField('r1b compresses', ofields.useCompresses.r1, 3),
    fromField('r1b compresses type', ofields.compressesType.r1),
    fromField('r1b séchage spontané', ofields.dry.r1),
    fromField('r1b nettoyage gants retirés', ofields.thirdGlovesRemoval.r1),
    fromField('r1b pose hdm (2024+)', ofields.handHygieneBeforeImplementation.r1[0]),
    fromField('r1b pose hdm type (2024+)', ofields.handHygieneBeforeImplementation.r1[1]),
    fromField('r1b pose hdm conforme (2024+)', ofields.handHygieneBeforeImplementation.r1[2]),
    fromField('r1b pose gants', ofields.implementationGloves.r1),
    fromField('r1b pose gants type', ofields.implementationGlovesType.r1),
    { f: 'r1b pkoi pas change gants après retrait stabilisateur', t: `Entretien avec l'audité`, h: true },
    fromField('r1b pkoi pas change gants après retrait stabilisateur (2023+)', ofields.whyNotGROnStabilizerChange.r1[0]),
    fromField('r1b pkoi pas change gants après retrait stabilisateur autre (2023+)', ofields.whyNotGROnStabilizerChange.r1[1]),
    fromField('r1b pkoi pas hdm avant antisepsie (2024+)', ofields.whyNotHHBeforeAntisepsis.r1[0]),
    fromField('r1b pkoi pas hdm avant antisepsie autre (2024+)', ofields.whyNotHHBeforeAntisepsis.r1[1]),
    fromField('r1b pkoi pas gants stériles pour réfection (2023+)', ofields.whyNotSGForAntisepsis.r1[0]),
    fromField('r1b pkoi pas gants stériles pour réfection autre (2023+)', ofields.whyNotSGForAntisepsis.r1[1])
  ]
}
